export enum Currency {
    USD = 'USD',
    EUR = 'EUR'
}

export const Currencies: Currency[] = [
    Currency.USD,
    Currency.EUR
];
